/**
 * Effectif d'une demande de devis : au moins 1 voyageur, 9 au plus.
 *
 * Cette règle ne vivait que dans les schémas de formulaire (`@massilia/features`) : le
 * contrat d'API, lui, acceptait `existingPassengerIds` et `newPassengers` vides — ou
 * absents. Sept demandes de production sont ainsi restées sans aucun voyageur, que
 * l'agent a chiffrées à l'aveugle (la réponse porte le bon effectif, la demande non).
 *
 * La mise à jour aggravait le trou : elle réécrit la liste (`deleteMany` puis
 * `createMany`), donc un payload sans voyageur EFFAÇAIT ceux de la demande, sans erreur.
 *
 * Source unique du formulaire et de l'API : les deux doivent accepter exactement les
 * mêmes demandes, sinon l'API laisse entrer ce que le formulaire ne saura plus rouvrir.
 */
export const ESTIMATE_PASSENGER_BOUNDS = { max: 9, min: 1 };
/** Message et champ porteur de l'erreur, partagés par le formulaire et l'API. */
export const ESTIMATE_PASSENGER_COUNT_ERROR = {
    message: 'Au moins 1 passager requis, maximum 9 passagers',
    path: ['newPassengers'],
};
/**
 * Vrai quand l'effectif total (voyageurs enregistrés + voyageurs saisis) tient dans les
 * bornes. À brancher en `.refine()` sur un schéma qui porte les deux champs.
 */
export function checkEstimatePassengerCount(data) {
    const total = (data.existingPassengerIds?.length ?? 0) + (data.newPassengers?.length ?? 0);
    return total >= ESTIMATE_PASSENGER_BOUNDS.min && total <= ESTIMATE_PASSENGER_BOUNDS.max;
}
